import en from "./en";
import ku from "./ku";
import ar from "./ar";

const messages = {
  en,
  ar,
  ku,
};

export default messages;
